import React from "react";
import secBanner from "../../../assets/images/osportwears/banner2.jpg";
import mobileSecBanner from "../../../assets/images/osportwears/banner phone.jpg";
const SecondBanner = () => {
  return (
    <div className="lg:px-20 py-10 md:px-10 px-5">
      <img className="md:block hidden" src={secBanner} alt="" />
      <img className="md:hidden " src={mobileSecBanner} alt="" />
    </div>
  );
};

export default SecondBanner;
